import React from 'react';
import './Footer.css'; // Optional: for styling

const Footer = () => {
    return (
        <footer className="footer2">
            {/*<div className="content-wrapper  outcomeFooterDiv" id="FooterDIV">*/}
            {/*    <p className='col center'>&copy; 2007 - 2025, American College of Surgeons*/}
            {/*        National Surgical Quality Improvement Program. All Rights Reserved.</p>*/}
            {/*</div>*/}
            <div>
                <p className='col center'>&copy; 2007 - 2025, American College of Surgeons National Surgical Quality Improvement Program. All Rights Reserved.</p>
            </div>
            {/*<p>&copy; 2025 My Application. All rights reserved.</p>*/}
        </footer>
    );
};

export default Footer;